import React from 'react';
import styles from './Separator.module.scss';

export default function Separator() {
  return <div className={styles.separator} />;
}
